/* eslint-disable class-methods-use-this */
import Vue from 'vue';
import GstplnApp, { GstplnAppCategory } from '../app';

export default class DyflexisApp extends GstplnApp {
  constructor(vue: Vue) {
    super(vue, 'app.booq-planner', {
      categories: [GstplnAppCategory.Integrations],
      underPaywall: true,
      hasMenuItem: false,
      configComponentImportFnc: () => import('@/components/apps/booq-planner/SettingsDialog.vue'),
    });
  }
}
